export enum SA_TOPICS {
    /**
     * @value Add topics
     */
    ADD_TOPIC = 'FRONT.SOCIAL_ADVOCACY.ADD_TOPIC.LABEL',
    /**
     * @value Press enter to add topics.
     */
    ADD_TOPIC_HELPER = 'FRONT.SOCIAL_ADVOCACY.ADD_TOPIC.HELPER',
    /**
     * @value This topic already exists.
     */
    CREATE_TOPIC_DUPLICATE_ERROR = 'FRONT.SOCIAL_ADVOCACY.CREATE_TOPIC.DUPLICATE_ERROR',
    /**
     * @value Delete topic
     */
    DELETE_TOPIC = 'FRONT.SOCIAL_ADVOCACY.DELETE_TOPIC',
    /**
     * @value <strong>%TOPIC%</strong> topic will be <strong>deleted permanently</strong>. It will no longer be associated with social posts. Related analytics won’t be visible anymore.
     */
    DELETE_TOPIC_WARNING = 'FRONT.SOCIAL_ADVOCACY.DELETE_TOPIC.WARNING',
    /**
     * @value Edit topic
     */
    EDIT_TOPIC = 'FRONT.SOCIAL_ADVOCACY.EDIT_TOPIC.LABEL',
    /**
     * @value Topic name cannot be empty.
     */
    EDIT_TOPIC_ERROR_EMPTY = 'FRONT.SOCIAL_ADVOCACY.EDIT_TOPIC.ERROR.EMPTY',
    /**
     * @value new topics
     */
    NEW_TOPICS = 'FRONT.SOCIAL_ADVOCACY.TOPICS.SORT.NEW_TOPICS',
    /**
     * @value Edit or remove this filter to display topics.
     */
    NO_TOPIC_REMOVE_TO_DISPLAY = 'FRONT.SOCIAL_ADVOCACY.SEARCH_TOPICS.NO_TOPIC.REMOVE_TO_DISPLAY',
    /**
     * @value Topics
     */
    PROGRAM_CREATION_STEP_TOPICS = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.STEP.TOPICS.LABEL',
    /**
     * @value Search topics
     */
    SEARCH_TOPICS = 'FRONT.SOCIAL_ADVOCACY.SEARCH_TOPICS.LABEL',
    /**
     * @value There is no topic <strong>%TOPIC%</strong>.
     */
    SEARCH_TOPICS_NO_TOPIC = 'FRONT.SOCIAL_ADVOCACY.SEARCH_TOPICS.NO_TOPIC',
    /**
     * @value Clear filter
     */
    SEARCH_TOPICS_NO_TOPIC_CLEAR_FILTER = 'FRONT.SOCIAL_ADVOCACY.SEARCH_TOPICS.NO_TOPIC.CLEAR_FILTER',
}
